import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyPolizasPropietario } from 'src/app/interfaces/body_polizas_propietario';
import { BodyRiesgosConsultable } from 'src/app/interfaces/body_riesgos_consultable';
import { BodyPropietario } from 'src/app/interfaces/bodyPropietario';
import { ResponsePolizasPropietario } from 'src/app/interfaces/response_poliza_propietario';
import { ResponseRiesgosConsultable } from 'src/app/interfaces/response_reisgos_consultable';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';
import { ERROR, NO_SARLAFT, FEEDBACK, INMUEBLE, COTIZACION_PAUSA,INFO_COMPLEMENTARIA, TIEMPO_INACTIVO } from 'src/app/routes.constants';

@Component({
  selector: 'app-datos-propietario',
  standalone: false,
  templateUrl: './datos-propietario.component.html',
  styleUrl: './datos-propietario.component.scss'
})
export class DatosPropietarioComponent implements OnInit {

  @ViewChild('primerNombre') primerNombre!: ElementRef;
  @ViewChild('segundoNombre') segundoNombre!: ElementRef;
  @ViewChild('primerApellido') primerApellido!: ElementRef;
  @ViewChild('segundoApellido') segundoApellido!: ElementRef;
  @ViewChild('correo') correoElec!: ElementRef;
  @ViewChild('paisNacimiento') paisNacimento!: ElementRef;
  @ViewChild('tipoIdentificacion') tipoIdentificacion!: ElementRef;
  @ViewChild('documentoIdentidad') documentoIdentidad!: ElementRef;
  @ViewChild('fechaExpedicion') fechaExpedicion!: ElementRef;

  emailPattern = environment.PATTERN_EMAIL;
  celularPattern = environment.PATTERN_CELULAR;
  identPatter = environment.PATTERN_IDENTIFICACION

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
  checador: any;
  saliendo: boolean = false;
  leadId: string = '';
  sessionId: string = '';
  responsePolizaPropietario!: ResponsePolizasPropietario;
  codAsesor: string = '';
  IdBitacora: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {

        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);

          this.datosGenerales.Propietario.primerNombre = this.formulario.get("primerNombre")?.value.split(' ')[0];
          this.datosGenerales.Propietario.segundoNombre = this.formulario.get("segundoNombre")?.value.split(' ')[0];
          this.datosGenerales.Propietario.primerApellido = this.formulario.get("primerApellido")?.value.split(' ')[0];
          this.datosGenerales.Propietario.segundoApellido = this.formulario.get("segundoApellido")?.value.split(' ')[0];
          this.datosGenerales.Propietario.paisNacimiento = this.formulario.get("paisNacimiento")?.value;
          this.datosGenerales.Propietario.tipoIdentificacion = this.formulario.get("tipoIdentificacion")?.value;
          this.datosGenerales.Propietario.numeroIdentificacion = this.formulario.get("documentoIdentidad")?.value;
          this.datosGenerales.Propietario.fechaExpedicion = this.formulario.get("fechaExpedicion")?.value;
          this.datosGenerales.Propietario.correo = this.formulario.get("correo")?.value;
            this.datosGenerales.Cliente.nombreCliente = this.formulario.get("primerNombre")?.value.split(' ')[0];

          this.parametro = JSON.stringify(this.datosGenerales);

          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '30', msnPll: 'tiempo inactivo_datos propietario1', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  public datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  json: string = '';
  jsonFinal: string = '';
  valorArrTemp: number = 0;
  valorAdmonTemp: number = 0;
  tipoPropiedad: string = '';
  selectTipoIdentificacion = "C";
  paisDefecto = 'Colombia';
  parametro: string = '';
  planSeleccionado: string = '';
  riesgoConsultabelResult!: ResponseRiesgosConsultable;
  private identificiones: string[] = [];
  bodyRiegos: BodyRiesgosConsultable = {
    SessionId: '',
    getRiesgos: false,
    asesorCode: '',
    bitacoraId: '',
    Producto: '',
    leadId: '',
    productsConfigurationData: {
      Tenant: {
        DocumentNumber: ''
      },
      PolicyHolder: {
        DocumentNumber: ''
      }
    }
  }

  datosEnvio: BodyPropietario = {
    SessionId: '',
    leadId: '',
    screenPercentage: '',
    productFamily: '',
    asesorCode: '',
    bitacoraId: '',
    getOwnerPolicies: false,
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        CountryOfBirth: '',
        DocumentNumber: '',
        DocumentType: '',
        ExpeditionDate: '',
        FirstName: '',
        Mail: '',
        MobilePhone: '',
        PersonalDataAuthorization: false,
        PersonalDataLastUpdated: '',
        PersonalDataVersion: '',
        SecondLastName: '',
        SecondName: ''
      },
      Property: {
        AdministrationValue: 0,
        ContractStartDate: '',
        Department: '',
        RentalFee: 0,
        TemporaryContracted: '',
        UseProperty: '',
        // new atrivutes for Property
        DepartmentCode: '',
        CityProperty: '',
        Code: '',
        CityCode: ''

      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  };

  private envioPoliza: BodyPolizasPropietario = {
    getOwnerPolicies: false,
    productFamily: "",
    SessionId: '',
    leadId: '',
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        CountryOfBirth: '',
        DocumentNumber: '',
        DocumentType: '',
        ExpeditionDate: '',
        FirstName: '',
        Mail: '',
        MobilePhone: '',
        PersonalDataAuthorization: false,
        PersonalDataLastUpdated: '',
        PersonalDataVersion: '',
        SecondLastName: '',
        SecondName: ''
      },
      Property: {
        AdministrationValue: 0,
        ContractStartDate: '',
        Department: '',
        RentalFee: 0,
        TemporaryContracted: '',
        UseProperty: ''
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  }

  formulario: FormGroup = new FormGroup({
    primerNombre: new FormControl('', [Validators.required]),
    segundoNombre: new FormControl(''),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl(''),
    correo: new FormControl('', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]),
    paisNacimiento: new FormControl('Colombia', [Validators.required]),
    tipoIdentificacion: new FormControl('C', [Validators.required]),
    documentoIdentidad: new FormControl('', [Validators.required, Validators.min(100000),
    Validators.max(9999999999)]),
    fechaExpedicion: new FormControl('', [Validators.required])
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;
  @Input() codigoAsesor?: string = '';
  @Input() bitacoraId: string = '';

  ngOnInit(): void {
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
        this.planSeleccionado = this.datosGenerales.PlanSeleccionado.plan;
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';
        this.codAsesor = this.codigoAsesor !== undefined ? this.codigoAsesor : '';
        this.IdBitacora = this.bitacoraId !== undefined ? this.bitacoraId : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.formulario.get("primerNombre")?.setValue(this.datosGenerales.Propietario.primerNombre);
          this.formulario.get("segundoNombre")?.setValue(this.datosGenerales.Propietario.segundoNombre);
          this.formulario.get("primerApellido")?.setValue(this.datosGenerales.Propietario.primerApellido);
          this.formulario.get("segundoApellido")?.setValue(this.datosGenerales.Propietario.segundoApellido);
          this.formulario.get("paisNacimiento")?.setValue(this.datosGenerales.Propietario.paisNacimiento);
          this.formulario.get("tipoIdentificacion")?.setValue(this.datosGenerales.Propietario.tipoIdentificacion);
          this.formulario.get("documentoIdentidad")?.setValue(this.datosGenerales.Propietario.numeroIdentificacion); this.datosGenerales.Propietario.fechaExpedicion = this.formulario.get("fechaExpedicion")?.value;
          this.formulario.get("correo")?.setValue(this.datosGenerales.Propietario.correo);
          this.formulario.get("fechaExpedicion")?.setValue(this.datosGenerales.Propietario.fechaExpedicion.toString());
          this.planSeleccionado = this.datosGenerales.PlanSeleccionado.plan;
        }
      }
    });

    console.log('datosGenerales datos propietario' + JSON.stringify(this.datosGenerales));
  }

  ngOnDestroy() {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.checador) {
      clearInterval(this.checador);
    }
  }

  get primerNombreNoValido() {
    return this.formulario.get("primerNombre")?.invalid
      && this.formulario.get("primerNombre")?.touched;
  }

  valPrimerNombre = false;
  valPrimerNombre2 = true;
  validacionPrimerNombre() {
    if (this.formulario.get("primerNombre")?.value === '') {
      this.valPrimerNombre = !this.valPrimerNombre;
      this.valPrimerNombre2 = !this.valPrimerNombre2;
    } else {
      this.valPrimerNombre = false;
      this.valPrimerNombre2 = true;
    }
  }

  get primerApellidoNoValido() {
    return this.formulario.get("primerApellido")?.invalid
      && this.formulario.get("primerApellido")?.touched;
  }

  valPrimerApellido = false;
  valPrimerApellido2 = true;
  validacionPrimerApellido() {
    if (this.formulario.get("primerApellido")?.value === '') {
      this.valPrimerApellido = !this.valPrimerApellido;
      this.valPrimerApellido2 = !this.valPrimerApellido2;
    } else {
      this.valPrimerApellido = false;
      this.valPrimerApellido2 = true;
    }
  }

  get paisNacimientoNoValido() {
    return this.formulario.get("paisNacimiento")?.invalid
      && this.formulario.get("paisNacimiento")?.touched;
  }

  valPaisNacimento = false;
  valPaisNacimento2 = true;
  validacionPaisNacimento() {
    if (this.formulario.get("paisNacimiento")?.value === '') {
      this.valPaisNacimento = !this.valPaisNacimento;
      this.valPaisNacimento2 = !this.valPaisNacimento2;
    } else {
      this.valPaisNacimento = false;
      this.valPaisNacimento2 = true;
    }
  }


  get tipoidentificacionNoValido() {
    return this.formulario.get("tipoIdentificacion")?.invalid
      && this.formulario.get("tipoIdentificacion")?.touched;
  }

  valTipoidentificacion = false;
  valTipoidentificacion2 = true;
  validacionTipoidentificacion() {
    if (this.formulario.get("tipoIdentificacion")?.value === '') {
      this.valTipoidentificacion = !this.valTipoidentificacion;
      this.valTipoidentificacion2 = !this.valTipoidentificacion2;
    } else {
      this.valTipoidentificacion = false;
      this.valTipoidentificacion2 = true;
    }
  }

  get documentoNoValido() {
    return this.formulario.get("documentoIdentidad")?.invalid
      && this.formulario.get("documentoIdentidad")?.touched;
  }

  valDocumentoIdentidad = false;
  valDocumentoIdentidad2 = true;
  validacionDocumentoIdentidad() {
    if (this.formulario.get("documentoIdentidad")?.value === '') {
      this.valDocumentoIdentidad = !this.valDocumentoIdentidad;
      this.valDocumentoIdentidad2 = !this.valDocumentoIdentidad2;
    } else {
      this.valDocumentoIdentidad = false;
      this.valDocumentoIdentidad2 = true;
    }
  }

  get fechaExpedicionNoValido() {
    return this.formulario.get("fechaExpedicion")?.invalid
      && this.formulario.get("fechaExpedicion")?.touched;
  }

  valFechaExpedicion = false;
  valFechaExpedicion2 = true;
  validacionFechaExpedicion() {
    if (this.formulario.get("fechaExpedicion")?.value === '') {
      this.valFechaExpedicion = !this.valFechaExpedicion;
      this.valFechaExpedicion2 = !this.valFechaExpedicion2;
    } else {
      this.valFechaExpedicion = false;
      this.valFechaExpedicion2 = true;
    }
  }

  get correoNoValido() {
    return this.formulario.get("correo")?.invalid
      && this.formulario.get("correo")?.touched;
  }

  valCorreo = false;
  valCorreo2 = true;
  validacionCorreo() {
    if (this.formulario.get("correo")?.value === '') {
      this.valCorreo = !this.valCorreo;
      this.valCorreo2 = !this.valCorreo2;
    } else {
      this.valCorreo = false;
      this.valCorreo2 = true;
    }
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  Continuar() {
    
    this.datosGenerales.Propietario.primerNombre = this.formulario.get("primerNombre")?.value.split(' ')[0];
    this.datosGenerales.Propietario.segundoNombre = this.formulario.get("segundoNombre")?.value.split(' ')[0];
    this.datosGenerales.Propietario.primerApellido = this.formulario.get("primerApellido")?.value.split(' ')[0];
    this.datosGenerales.Propietario.segundoApellido = this.formulario.get("segundoApellido")?.value.split(' ')[0];
    this.datosGenerales.Propietario.paisNacimiento = this.formulario.get("paisNacimiento")?.value;
    this.datosGenerales.Propietario.tipoIdentificacion = this.formulario.get("tipoIdentificacion")?.value;
    this.datosGenerales.Propietario.numeroIdentificacion = this.formulario.get("documentoIdentidad")?.value;
    this.datosGenerales.Propietario.fechaExpedicion = this.formulario.get("fechaExpedicion")?.value;
    this.datosGenerales.Propietario.correo = this.formulario.get("correo")?.value;

    this.datosGenerales.Cliente.nombreCliente = this.formulario.get("primerNombre")?.value.split(' ')[0];

    this.parametro = JSON.stringify(this.datosGenerales);


    this._dataLayerService.logPlanes('ecommerce_step_5', 'Arrendamiento', 'Datos propietario',
      this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
      this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
      this.datosGenerales.InfoArrendamiento.tipoPropiedad,
      this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.CityProperty || '',
      this.datosGenerales.InfoArrendamiento.duracionContrato,
      this.datosGenerales.InfoArrendamiento.fechaContrato, this.datosGenerales.PlanSeleccionado.plan,
      this.datosGenerales.PlanSeleccionado.valorPlan.toString(), this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
      this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false');


    this.GuardarDataLayer();
  }


  private GuardarDataLayer() {
    const datepipe: DatePipe = new DatePipe('en-US')
    let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

    this.datosEnvio.SessionId = this.sessionId;
    this.datosEnvio.productFamily = 'Arrendamientos';
    this.datosEnvio.leadId = this.leadId;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.datosEnvio.asesorCode = this.codAsesor;
    }

    if (this.codAsesor != '') {
      this.datosEnvio.asesorCode = this.codAsesor;
    }
    else {
      this.datosEnvio.asesorCode = this.codAsesor;
    }

    this.datosEnvio.bitacoraId = this.IdBitacora;
    this.datosEnvio.getOwnerPolicies = true;
    this.datosEnvio.screenPercentage = '30';

    this.datosEnvio.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
    this.datosEnvio.productsConfigurationData.PolicyHolder.LastName = this.formulario.get("primerApellido")?.value.split(' ')[0];
    this.datosEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosEnvio.productsConfigurationData.PolicyHolder.FirstName = this.formulario.get("primerNombre")?.value.split(' ')[0];
    this.datosEnvio.productsConfigurationData.PolicyHolder.Mail = this.formulario.get("correo")?.value;
    this.datosEnvio.productsConfigurationData.PolicyHolder.ExpeditionDate = this.formulario.get("fechaExpedicion")?.value;
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentNumber = this.formulario.get("documentoIdentidad")?.value.toString();
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentType = this.formulario.get("tipoIdentificacion")?.value;
    this.datosEnvio.productsConfigurationData.PolicyHolder.CountryOfBirth = this.formulario.get("paisNacimiento")?.value;
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondLastName = this.formulario.get("segundoApellido")?.value.split(' ')[0];
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondName = this.formulario.get("segundoNombre")?.value.split(' ')[0];
    this.datosEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.datosEnvio.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.datosEnvio.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.datosEnvio.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.datosEnvio.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.datosEnvio.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.datosEnvio.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
    this.datosEnvio.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
    this.datosEnvio.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.datosEnvio.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.datosEnvio.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
    this.datosEnvio.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;

    this.orquestadorService.postOrquestadorDatosPropiertario(this.datosEnvio).
      subscribe(
        (data) => {

          console.log('data  postOrquestadorDatosPropiertario: '+JSON.stringify(data));


          this.responsePolizaPropietario = data;
          console.log('Poliza propietario '+JSON.stringify(this.responsePolizaPropietario));
          this.bodyRiegos.SessionId = this.sessionId;

          if (this.codAsesor != '') {
            this.bodyRiegos.asesorCode = this.codAsesor;
          }
          else {
            this.bodyRiegos.asesorCode = this.codAsesor;
          }

          this.bodyRiegos.bitacoraId = this.IdBitacora;
          this.bodyRiegos.leadId = this.leadId;
          this.bodyRiegos.Producto = 'DigitalArrendamientos';
          this.bodyRiegos.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
          this.bodyRiegos.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion.toString();
          this.bodyRiegos.getRiesgos = true

           if(data.data.owner ===true){
            this.parametro = JSON.stringify(this.datosGenerales);
             this.router.navigate([COTIZACION_PAUSA, { porcPll: '30', msnPll: 'Validacion de poliza.', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
           } else {
            this.orquestadorService.postOrquestadoRiesgosConsultables(this.bodyRiegos).subscribe(
              data => {
                if (data !== null) {
                  console.log(' riesgoConsultabelResult antes: '+JSON.stringify(this.riesgoConsultabelResult));
                  this.riesgoConsultabelResult = data;
                  this.riesgoConsultabelResult.data[0].mensajeValidacion = this.riesgoConsultabelResult.data[0].mensajeValidacion.replace('�', '-').replace('�', '-').replace('�', '-').replace('�', '-').replace('�', '-');
                  this.riesgoConsultabelResult.data[1].mensajeValidacion = this.riesgoConsultabelResult.data[1].mensajeValidacion.replace('�', '-').replace('�', '-').replace('�', '-').replace('�', '-').replace('�', '-');
                  console.log(' riesgoConsultabelResult despues: '+JSON.stringify(this.riesgoConsultabelResult));
                  this.datosGenerales.ResponseRiesgoConsultable = this.riesgoConsultabelResult.data;
                  this.parametro = JSON.stringify(this.datosGenerales);
  
                  if (this.riesgoConsultabelResult !== undefined) {
  
                    if (this.riesgoConsultabelResult.ConsultaRiesgo.error === 'Hubo problemas para comunicarse con el servicio de consulta de riesgo') {
                      this.router.navigate([ERROR, { porcPll: '30', msnPll: 'Hubo problemas para comunicarse con el servicio de consulta de riesgo', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
                      return;
                    }
  
                    if (this.riesgoConsultabelResult.data[0].esRiesgo &&
                      this.riesgoConsultabelResult.data[0].tipoValidacion == 'B') {
                      this.router.navigate([NO_SARLAFT, { porcPll: '0', msnPll: 'Propietario con riesgos consultables.', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
                      return;
                    }
  
                    if (this.riesgoConsultabelResult.data[1].esRiesgo &&
                      this.riesgoConsultabelResult.data[1].tipoValidacion == 'B') {
                      this.router.navigate([FEEDBACK, { porcPll: '30', msnPll: 'Inquilino con riesgos consultables.', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
                      return;
                    }
  
                    if (this.responsePolizaPropietario.error !== true) {
                      this.router.navigate([INMUEBLE, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
                      return;
                    }
                    else {
                      this.router.navigate([COTIZACION_PAUSA, { porcPll: '30', msnPll: 'Validacion de poliza.', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
                      return;
                    }
                  }
  
                }
              },
              (error) => {
                this.router.navigate([ERROR, { porcPll: '30', msnPll: 'Falla servicio riegos consultables', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
                return;
              }
            );
           }


          

          // this.router.navigate(['Inmueble', { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          // return;
        }
      );

  }
}
